import { render, staticRenderFns } from "./StatusShow.vue?vue&type=template&id=34f8cb6a&"
import script from "./StatusShow.vue?vue&type=script&lang=js&"
export * from "./StatusShow.vue?vue&type=script&lang=js&"
import style0 from "./StatusShow.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports